/* eslint-disable no-restricted-globals */
import ResizeObserverPolyfill from 'resize-observer-polyfill';

// Finding the global variable.
const _global = (function () {
  if (typeof global !== 'undefined' && global.Math === Math) {
    return global;
  }

  if (typeof self !== 'undefined' && self.Math === Math) {
    return self;
  }

  if (typeof window !== 'undefined' && window.Math === Math) {
    return window;
  }
})();

// If ResizeObserver doesn't exist, set the Polyfill.
if (!_global.ResizeObserver) {
  _global.ResizeObserver = ResizeObserverPolyfill;
}
